import { render, staticRenderFns } from "./PurchaseOnHold.vue?vue&type=template&id=655d73de&scoped=true&lang=pug&"
import script from "./PurchaseOnHold.vue?vue&type=script&lang=js&"
export * from "./PurchaseOnHold.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOnHold.vue?vue&type=style&index=0&id=655d73de&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d73de",
  null
  
)

/* custom blocks */
import block0 from "./PurchaseOnHold.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports